module.exports = __webpack_public_path__ + "img/paytabs.cd725212.png";